import clsx from 'clsx'
import { CalendarIcon, X } from 'lucide-react'
import React from 'react'

import {
  convertToUTCDate,
  getFormattedDate,
  getISODateString,
} from '../../../utils'
import { Calendar } from '../../ui/calendar'
import { Popover, PopoverContent, PopoverTrigger } from '../../ui/popover'
import { type SingleSelectedValueFilter } from '../types'

const DateFilter = ({
  selectValue,
  selectedValue,
  rangeType,
}: SingleSelectedValueFilter & { rangeType: string }) => {
  const handleSelect = (date: Date | undefined) => {
    if (!date) return
    const dateStr = getISODateString(date)
    selectValue(dateStr)
  }

  const dateConversionMethod = (selectedDate: string) => {
    if (selectedDate) {
      return convertToUTCDate(new Date(selectedDate))
    }
  }

  const handleClearSelection = (e: React.MouseEvent) => {
    e.stopPropagation()
    selectValue('')
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <div
          role='combobox'
          style={{ width: '300px' }}
          className={clsx({
            'rounded-md bg-slate-50 flex items-center justify-between px-2 py-1 text-sm cursor-pointer':
              true,
            'text-thatch-purple': selectedValue,
            'text-ds-text-secondary': !selectedValue,
          })}
        >
          {selectedValue
            ? (
              <span>
                {rangeType} {getFormattedDate(selectedValue, { timeZone: 'UTC' })}
              </span>
              )
            : (
              <span>{rangeType} date</span>
              )}
          <div className='ml-auto flex items-center justify-between space-x-2 shrink-0'>
            {selectedValue && (
              <X
                className='cursor-pointer h-4 w-4'
                onClick={handleClearSelection}
              />
            )}
            <CalendarIcon className='h-4 w-4' size={20} />
          </div>
        </div>
      </PopoverTrigger>
      <PopoverContent className='w-auto p-0' align='start'>
        <Calendar
          mode='single'
          selected={dateConversionMethod(selectedValue)}
          onSelect={handleSelect}
          disabled={() => false}
          autoFocus
          defaultMonth={
            selectedValue ? dateConversionMethod(selectedValue) : new Date()
          }
        />
      </PopoverContent>
    </Popover>
  )
}

export default DateFilter
